import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2db28390"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 col-lg-8" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-plus" }, null, -1))
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "row" }
const _hoisted_6 = ["href"]
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-md-12 mb-6 fv-row fv-plugins-icon-container" }
const _hoisted_13 = { class: "col-md-6 fv-row fv-plugins-icon-container" }
const _hoisted_14 = { class: "col-md-6 mb-8 fv-row fv-plugins-icon-container" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator" }, null, -1))
const _hoisted_16 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_17 = {
  key: 0,
  class: "d-flex justify-content-center my-5"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "pb-5" }
const _hoisted_21 = ["data-index"]
const _hoisted_22 = { class: "d-flex justify-content-between w-100" }
const _hoisted_23 = { class: "d-flex" }
const _hoisted_24 = ["src", "alt"]
const _hoisted_25 = {
  key: 1,
  class: "fa-solid fa-building me-3 no-logo"
}
const _hoisted_26 = { class: "d-flex flex-column justify-content-center fs-4 offer-title" }
const _hoisted_27 = { class: "m-0" }
const _hoisted_28 = { class: "m-0 mt-1 fw-normal" }
const _hoisted_29 = {
  key: 0,
  class: "d-flex align-items-center fs-4 me-5 date-publication justify-content-end"
}
const _hoisted_30 = {
  key: 0,
  class: "m-0 fw-normal mt-1 date-publication"
}
const _hoisted_31 = ["href"]
const _hoisted_32 = ["href"]
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = { class: "d-flex align-items-center justify-content-between w-100" }
const _hoisted_35 = {
  key: 0,
  class: "m-0 fw-normal mt-1 date-publication"
}
const _hoisted_36 = {
  key: 1,
  class: "m-0 fw-normal mt-1 date-publication"
}
const _hoisted_37 = ["href"]
const _hoisted_38 = ["href"]
const _hoisted_39 = { key: 0 }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center my-5" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "spinner-border text-primary",
    role: "status"
  })
], -1))
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = { class: "m-5 d-flex justify-content-center" }
const _hoisted_43 = { class: "col-12 col-lg-4" }
const _hoisted_44 = ["innerHTML"]
const _hoisted_45 = ["innerHTML"]
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { class: "d-flex justify-content-center w-100" }
const _hoisted_48 = { class: "d-flex" }
const _hoisted_49 = { class: "d-flex flex-column justify-content-center fs-4" }
const _hoisted_50 = { class: "m-0" }
const _hoisted_51 = {
  key: 0,
  class: "d-flex justify-content-center w-100 pe-10"
}
const _hoisted_52 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_53 = { class: "d-flex flex-column justify-content-center fs-4" }
const _hoisted_54 = { class: "m-0 text-center" }
const _hoisted_55 = ["onClick"]
const _hoisted_56 = {
  key: 1,
  class: "d-flex"
}
const _hoisted_57 = { class: "d-flex flex-column justify-content-center fs-4" }
const _hoisted_58 = { class: "m-0 text-center" }
const _hoisted_59 = ["onClick"]
const _hoisted_60 = {
  key: 1,
  class: "d-flex justify-content-center w-100 pe-10"
}
const _hoisted_61 = { class: "d-flex" }
const _hoisted_62 = { class: "d-flex flex-column justify-content-center fs-4" }
const _hoisted_63 = { class: "m-0" }
const _hoisted_64 = ["onClick"]
const _hoisted_65 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AdmissibleTrackingSheet = _resolveComponent("AdmissibleTrackingSheet")!
  const _component_BasicCardAction = _resolveComponent("BasicCardAction")!
  const _component_BasicCard = _resolveComponent("BasicCard")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_DateInput = _resolveComponent("DateInput")!
  const _component_CardAccordion = _resolveComponent("CardAccordion")!
  const _component_StaggeredListTransition = _resolveComponent("StaggeredListTransition")!
  const _component_vue_awesome_paginate = _resolveComponent("vue-awesome-paginate")!
  const _component_AdmissibleCv = _resolveComponent("AdmissibleCv")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_BasicCardAction, {
        class: "mb-10",
        title: _ctx.$t('views.portal.search.suiviRechercheEmployeur.card.cardTitle')
      }, {
        "btn-content": _withCtx(() => [
          _createVNode(_component_router_link, {
            to: { name: 'form-suivi-recherche-employeur', params: { id: '' }},
            class: "btn btn-icon btn-info"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        "card-body-content": _withCtx(() => [
          _createVNode(_component_AdmissibleTrackingSheet)
        ]),
        _: 1
      }, 8, ["title"]),
      _createVNode(_component_BasicCard, {
        class: "mb-10",
        title: _ctx.$t('views.portal.search.partners')
      }, {
        default: _withCtx(() => [
          _createElementVNode("p", {
            innerHTML: _ctx.$t('views.portal.search.partnersClickNotice')
          }, null, 8, _hoisted_4),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partners, (partner) => {
              return (_openBlock(), _createElementBlock("div", {
                key: partner.id,
                class: "col-4 col-sm-3 col-md-2 d-flex justify-content-center"
              }, [
                _createElementVNode("a", {
                  target: "_blank",
                  href: partner.web
                }, [
                  _createElementVNode("img", {
                    src: partner.logo,
                    alt: partner.nom,
                    width: "72"
                  }, null, 8, _hoisted_7)
                ], 8, _hoisted_6)
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["title"]),
      (_ctx.cmsData.forumInvitation)
        ? (_openBlock(), _createBlock(_component_BasicCard, {
            key: 0,
            class: "mb-10",
            title: _ctx.$t('views.portal.search.forumInvitation.cardTitle')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("p", {
                  class: "text-center",
                  innerHTML: _ctx.$t('views.portal.search.forumInvitation.title', {
            name: _ctx.cmsData.forumInvitation.name,
            date: _ctx.formatDate(_ctx.cmsData.forumInvitation.date).toLowerCase()
          })
                }, null, 8, _hoisted_9),
                _createElementVNode("a", {
                  class: "btn btn-info btn-violet",
                  href: _ctx.cmsData.forumInvitation.link
                }, _toDisplayString(_ctx.$t('views.portal.search.forumInvitation.btnLink')), 9, _hoisted_10)
              ])
            ]),
            _: 1
          }, 8, ["title"]))
        : _createCommentVNode("", true),
      _createVNode(_component_BasicCard, {
        class: "mb-10",
        id: "offers",
        title: _ctx.$t('views.portal.search.offers')
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_TextInput, {
                modelValue: _ctx.search.query,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search.query) = $event)),
                name: "query",
                "inline-icon": "fa-solid fa-search",
                placeholder: _ctx.$t('views.portal.search.offersCard.searchPlaceholder')
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_DateInput, {
                modelValue: _ctx.search.publicationDateBefore,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search.publicationDateBefore) = $event)),
                name: "publicationDateBefore",
                label: _ctx.$t('views.portal.search.offersCard.publicationDateBefore')
              }, null, 8, ["modelValue", "label"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_DateInput, {
                modelValue: _ctx.search.publicationDateAfter,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.search.publicationDateAfter) = $event)),
                name: "publicationDateAfter",
                label: _ctx.$t('views.portal.search.offersCard.publicationDateAfter')
              }, null, 8, ["modelValue", "label"])
            ]),
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              (!_ctx.offers.length && !_ctx.offersLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    ((_ctx.search.query || _ctx.search.publicationDateAfter || _ctx.search.publicationDateBefore))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.$t('views.portal.search.offersCard.noOffersWithFilters')), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.$t('views.portal.search.offersCard.noOffers')), 1))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_StaggeredListTransition, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.offers, (offer, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: i,
                          "data-index": i,
                          class: "my-3"
                        }, [
                          (_openBlock(), _createBlock(_component_CardAccordion, {
                            context: "offer",
                            "id-key": offer.id,
                            key: i,
                            "data-index": i
                          }, {
                            header: _withCtx(() => [
                              _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("div", _hoisted_23, [
                                  (offer.logo)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: offer.logo,
                                        alt: 'Logo' + offer.company.name,
                                        class: "me-3",
                                        width: "58"
                                      }, null, 8, _hoisted_24))
                                    : (_openBlock(), _createElementBlock("i", _hoisted_25)),
                                  _createElementVNode("div", _hoisted_26, [
                                    _createElementVNode("h5", _hoisted_27, _toDisplayString(offer.title), 1),
                                    _createElementVNode("h6", _hoisted_28, _toDisplayString(offer.company.name), 1)
                                  ])
                                ]),
                                (offer.publicationDate)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                      (offer.publicationDate)
                                        ? (_openBlock(), _createElementBlock("h5", _hoisted_30, _toDisplayString(_ctx.formatDate(offer.publicationDate).toLowerCase()), 1))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            content: _withCtx(() => [
                              _createElementVNode("div", null, [
                                (offer.applicationAction.linkType === 'link')
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      class: "btn btn-primary btn-violet",
                                      href: offer.applicationAction.link,
                                      target: "_blank"
                                    }, _toDisplayString(_ctx.$t('views.portal.search.offersCard.apply')), 9, _hoisted_31))
                                  : _createCommentVNode("", true),
                                (offer.applicationAction.linkType === 'mail')
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 1,
                                      class: "btn btn-primary btn-violet",
                                      href: 'mailto:' + offer.applicationAction.link
                                    }, _toDisplayString(_ctx.$t('views.portal.search.offersCard.apply')), 9, _hoisted_32))
                                  : _createCommentVNode("", true),
                                _createElementVNode("p", {
                                  innerHTML: offer.description.replace(/\n/g, '<br />')
                                }, null, 8, _hoisted_33)
                              ])
                            ]),
                            footer: _withCtx(() => [
                              _createElementVNode("div", _hoisted_34, [
                                (offer.startDate !== '0000-00-00')
                                  ? (_openBlock(), _createElementBlock("h5", _hoisted_35, _toDisplayString(_ctx.$t('views.portal.search.offersCard.toStartAt')) + " " + _toDisplayString(_ctx.formatDate(offer.startDate)), 1))
                                  : (_openBlock(), _createElementBlock("h5", _hoisted_36)),
                                (offer.applicationAction.linkType === 'link')
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 2,
                                      class: "btn btn-primary btn-violet",
                                      href: offer.applicationAction.link,
                                      target: "_blank"
                                    }, _toDisplayString(_ctx.$t('views.portal.search.offersCard.apply')), 9, _hoisted_37))
                                  : _createCommentVNode("", true),
                                (offer.applicationAction.linkType === 'mail')
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 3,
                                      class: "btn btn-primary btn-violet",
                                      href: 'mailto:' + offer.applicationAction.link
                                    }, _toDisplayString(_ctx.$t('views.portal.search.offersCard.apply')), 9, _hoisted_38))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["id-key", "data-index"]))
                        ], 8, _hoisted_21))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.offersLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, _hoisted_41))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_42, [
                  _createVNode(_component_vue_awesome_paginate, {
                    modelValue: _ctx.offersCurrentPage,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.offersCurrentPage) = $event)),
                    "total-items": _ctx.offersTotalItems,
                    "items-per-page": 20,
                    "max-pages-shown": 5,
                    "pagination-container-class": "d-flex flex-wrap",
                    "paginate-buttons-class": "btn btn-icon btn-lg btn-light mx-1 my-1",
                    "active-page-class": "btn-info",
                    "next-button-class": "btn-light-info",
                    "back-button-class": "btn-light-info",
                    "first-page-button-class": "btn-light-info",
                    "last-page-button-class": "btn-light-info",
                    type: "link",
                    "link-url": "/espace-admissible/recherche?page=[page]",
                    "hide-prev-next": _ctx.offersTotalItems <= 20
                  }, null, 8, ["modelValue", "total-items", "hide-prev-next"])
                ])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["title"])
    ]),
    _createElementVNode("div", _hoisted_43, [
      (_ctx.cmsData.cmsInfo?.platforms?.text)
        ? (_openBlock(), _createBlock(_component_BasicCard, {
            key: 0,
            class: "mt-10 mt-lg-0 mb-10",
            title: _ctx.cmsData.cmsInfo?.platforms?.title
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", {
                innerHTML: _ctx.cmsData.cmsInfo?.platforms?.text
              }, null, 8, _hoisted_44)
            ]),
            _: 1
          }, 8, ["title"]))
        : _createCommentVNode("", true),
      _createVNode(_component_BasicCard, {
        class: "mt-10 mt-lg-0 mb-10",
        title: _ctx.$t('views.portal.search.cvArea.card.cardTitle')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_AdmissibleCv)
        ]),
        _: 1
      }, 8, ["title"]),
      (_ctx.cmsData.cmsInfo?.coaching?.text)
        ? (_openBlock(), _createBlock(_component_BasicCard, {
            key: 1,
            class: "mt-10 mt-lg-0 mb-10",
            title: _ctx.cmsData.cmsInfo?.coaching?.title
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", {
                innerHTML: _ctx.cmsData.cmsInfo?.coaching?.text
              }, null, 8, _hoisted_45)
            ]),
            _: 1
          }, 8, ["title"]))
        : _createCommentVNode("", true),
      (_ctx.cmsData.ateliers?.ateliers?.length)
        ? (_openBlock(), _createBlock(_component_BasicCard, {
            key: 2,
            id: "ateliers",
            class: "mt-10 mt-lg-0 mb-10",
            title: _ctx.$t('views.portal.search.ateliersCardTitle')
          }, {
            default: _withCtx(() => [
              (_ctx.cmsData.ateliers?.ateliers?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cmsData.ateliers.ateliers, (atelier) => {
                      return (_openBlock(), _createBlock(_component_CardAccordion, {
                        color: atelier.isInscrit ? 'success' : 'secondary',
                        class: "my-4",
                        context: "ateliers",
                        "id-key": atelier.id,
                        key: atelier.id
                      }, {
                        header: _withCtx(() => [
                          _createElementVNode("div", _hoisted_47, [
                            _createElementVNode("div", _hoisted_48, [
                              _createElementVNode("div", _hoisted_49, [
                                _createElementVNode("h5", _hoisted_50, _toDisplayString(atelier.intitule || _ctx.$t('views.portal.search.ateliersCard.prefixTitle')) + " " + _toDisplayString(_ctx.formatDate(atelier.dateDebut || atelier.date)), 1)
                              ])
                            ])
                          ])
                        ]),
                        content: _withCtx(() => [
                          (!atelier.isInscrit)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                (_ctx.cmsData.ateliers.canRegister)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                      _createElementVNode("div", _hoisted_53, [
                                        _createElementVNode("h5", _hoisted_54, [
                                          _createElementVNode("i", null, _toDisplayString(atelier.quota - atelier.nbIns) + " " + _toDisplayString(_ctx.$t('views.portal.search.ateliersCard.remainingInscriptions')), 1)
                                        ]),
                                        _createElementVNode("button", {
                                          class: "btn btn-primary btn-violet mt-5",
                                          onClick: ($event: any) => (_ctx.registerAtelier(atelier))
                                        }, _toDisplayString(_ctx.$t('views.portal.search.ateliersCard.register')), 9, _hoisted_55)
                                      ])
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                      _createElementVNode("div", _hoisted_57, [
                                        _createElementVNode("h5", _hoisted_58, [
                                          _createElementVNode("i", null, _toDisplayString(atelier.quota - atelier.nbIns) + " " + _toDisplayString(_ctx.$t('views.portal.search.ateliersCard.remainingInscriptions')), 1)
                                        ]),
                                        _createElementVNode("button", {
                                          class: "btn btn-info btn-violet mt-5 disabled",
                                          onClick: ($event: any) => (_ctx.registerAtelier(atelier))
                                        }, _toDisplayString(_ctx.$t('views.portal.search.ateliersCard.registerDisabled')), 9, _hoisted_59)
                                      ])
                                    ]))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                _createElementVNode("div", _hoisted_61, [
                                  _createElementVNode("div", _hoisted_62, [
                                    _createElementVNode("h5", _hoisted_63, [
                                      _createElementVNode("i", null, _toDisplayString(_ctx.$t('views.portal.search.ateliersCard.registered')), 1)
                                    ]),
                                    _createElementVNode("button", {
                                      class: "btn btn-info mt-5",
                                      onClick: ($event: any) => (_ctx.unregisterAtelier(atelier))
                                    }, _toDisplayString(_ctx.$t('views.portal.search.ateliersCard.unregister')), 9, _hoisted_64)
                                  ])
                                ])
                              ]))
                        ]),
                        _: 2
                      }, 1032, ["color", "id-key"]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_65, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t('views.portal.search.ateliersCard.noAteliers')), 1)
                  ]))
            ]),
            _: 1
          }, 8, ["title"]))
        : _createCommentVNode("", true)
    ])
  ]))
}